import RequestError from "@/types/utils/RequestError"
import { createApiClient } from "@/utils/httpClient"

const apiDisponibilidade = createApiClient({
  baseURL: process.env.NEXT_PUBLIC_API_URL || 'https://assine3-be.estadao.com.br/',
})

export const getAddress = async (cd_oferta?:string, cep?: string) => {
  return apiDisponibilidade.get(`v1/search/offer/value/${cd_oferta}/${cep}`)
          .then((response) => {
              if(!response.data){
                  throw new Error(`ERRO NO GET OFFER, OBJETO RECEBIDO: ${JSON.stringify(response.data)}`)
              }
              return response.data
          }).catch((err: RequestError) => {
              throw err
          })
}

